import { getCookie } from 'cookies-next';
import jwtDecode from 'jwt-decode';
import axios from 'lib/data/axios';
import getUrl from 'lib/utils/getUrl';
import { NextApiRequest } from 'next';

export interface GetMyDataProps {
  articleId?: string;
  req?: NextApiRequest;
}

const myDataFactory = (endpoint: string) => (props?: GetMyDataProps) => {
  const token = getToken(props?.req);
  const userId = getUserId(props?.req);
  const articleId = props?.articleId;

  if (!userId || !endpoint) {
    return;
  }

  const path = [userId, endpoint, articleId].filter(Boolean).join('/');
  const url = getUrl(`/mydata/${path}`)?.href;

  if (!url || !token) {
    return;
  }

  return axios.get(url, {
    headers: {
      'X-API-Token': token,
    },
  });
};

export const getSavedArticlesIds = myDataFactory('getSavedArticleIds');

export const saveArticle = myDataFactory('saveArticle');

export const removeSavedArticle = myDataFactory('removeSavedArticle');

export const setFirstLoginTime = myDataFactory('setFirstLoginTime');

const getToken = (req?: NextApiRequest) => req?.cookies?.login_token || getCookie('login_token')?.toString();

const getUserId = (req?: NextApiRequest) => {
  const token = getToken(req);
  const payload = token ? jwtDecode<any>(token) : {};

  return payload?.data?.cc as string | undefined;
};
